


























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { TransferSchedule } from "@/shared/types";
import { getScheduleDescription } from "@/shared/components/contributionsV3/scheduleDescriptions";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class CancelConfirmationModal extends Vue {
  themeStore = useThemeStore();
  submitting = false;

  @Prop({required: true})
  cancelModalVisible: boolean;

  @Prop({required: true})
  schedule: TransferSchedule;

  get scheduleDescription (): string {
    return getScheduleDescription(this.schedule);
  }

  onCancel (): void {
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.submitting = true;
    this.$emit("confirm-cancellation");
  }

  onShow (): void {
    this.submitting = false;
  }
}
